export default __webpack_public_path__ + "static/media/Group 382.954f285c.svg";